import {
    TOGGLE_SEARCH_PRODUCT_FOCUS,
    TOGGLE_PROMOTIONS_MODAL,
    SHOW_CHANGE_TIME_MODAL,
    SHOW_TIME_SLOT_TAKEN_APP_REDIRECT_NOTICE,
    TOGGLE_SHOPPING_CART_MODAL,
    CLEAR_CART_AND_PROMO_MODALS,
    SAVE_SELECTED_RESTAURANT
} from '../actions/types';

const INITIAL_STATE = {
    isSearchProductOnFocus: false,
    isPromotionsModalOpen: false,
    isChangeTimeModalOpen: false,
    isShoppingCartModalOpen: false,
    showTimeSlotTakenAppRedirectNotice: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TOGGLE_SEARCH_PRODUCT_FOCUS:
            return { ...state, isSearchProductOnFocus: action.payload }
        case TOGGLE_PROMOTIONS_MODAL:
            return {
                ...state,
                isPromotionsModalOpen: !state.isPromotionsModalOpen
            }
        case SHOW_CHANGE_TIME_MODAL:
            return {
                ...state,
                isChangeTimeModalOpen: action.payload
            }
        case SHOW_TIME_SLOT_TAKEN_APP_REDIRECT_NOTICE:
            return {
                ...state,
                showTimeSlotTakenAppRedirectNotice: action.payload
            }
        case TOGGLE_SHOPPING_CART_MODAL:
            return {
                ...state,
                isShoppingCartModalOpen: !state.isShoppingCartModalOpen
            }
        case CLEAR_CART_AND_PROMO_MODALS:
            return {
                ...state,
                isPromotionsModalOpen: false,
                isChangeTimeModalOpen: false,
                isShoppingCartModalOpen: false,
                showTimeSlotTakenAppRedirectNotice: false
            }
        case SAVE_SELECTED_RESTAURANT:
            return {
                ...state,
                showTimeSlotTakenAppRedirectNotice: false
            }
        default:
            return state;
    }
};